export const splitImg = (src: string, row: number, column: number) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src + "?time=" + new Date();
    img.setAttribute("crossOrigin", "Anonymous");

    const canvas = document.createElement("canvas");
    const ctx: any = canvas.getContext("2d");
    let wpiece = 0;
    let hpiece = 0;
    img.onload = function () {
      wpiece = Math.floor(img.naturalWidth / column);
      hpiece = Math.floor(img.naturalHeight / row);
      canvas.width = wpiece;
      canvas.height = hpiece;
      const result = [];
      for (let i = 0; i < row; i++) {
        for (let j = 0; j < column; j++) {
          ctx.drawImage(
            img,
            j * wpiece,
            i * hpiece,
            wpiece,
            hpiece,
            0,
            0,
            wpiece,
            hpiece
          );
          const src = canvas.toDataURL();
          result.push({
            row: i + 1,
            col: j + 1,
            url: src,
          });
        }
      }
      resolve(result);
    };
    img.onerror = (e) => {
      reject(e);
    };
  });
